import { create } from 'zustand'
import { BonusesSlice, createBonusesSlice } from './slices/bonusesSlice'
import { FlexiBonusOption } from '@amusnet/bonuses-http-client'
import { Bonus, FreeSpinsBonus } from '@amusnet/mgs-ws-client'

export interface FreeSpinsBonusesStoreState {
    bonuses: FreeSpinsBonus[]
    setBonuses: (bonuses: FreeSpinsBonus[]) => void
    activeBonus?: FreeSpinsBonus
    setActiveBonus: (bonus?: FreeSpinsBonus) => void
    hasActiveBonusesLeft: boolean
    setHasActiveBonusesLeft: (hasMore: boolean) => void
    remainingSpins: number
    setRemainingSpins: (remainingSpins: number) => void
    showRemainingSpinsBanner: boolean
    setShowRemainingSpinsBanner: (shouldShow: boolean) => void
    isModalOpened: boolean
    setIsModalOpened: (isModalOpened: boolean) => void
    isThereClaimingError: boolean
    setIsThereClaimingError: (isThereClaimingError: boolean) => void
    isBonusAlreadyClaimed: boolean
    setIsBonusAlreadyClaimed: (isBonusAlreadyClaimed: boolean) => void
    isRecovery: boolean
    setIsRecovery: (isRecovery: boolean) => void
    isFreespinsPressStartCounterActive: boolean
    setIsFreespinsPressStartCounterActive: (isActive: boolean) => void
    selectFlexiBonusOption: (option: FlexiBonusOption | null) => void
    selectedFlexiBonusOption: FlexiBonusOption | null
    showFlexiIntroModal: boolean
    setShowFlexiIntroModal: (show: boolean) => void
    flexiQueue: Bonus[]
    nonFlexiBonuses: Bonus[]
    setFlexiQueue: (bonuses: Bonus[]) => void
    setNonFlexiBonuses: (bonuses: Bonus[]) => void
    removeBonusFromFlexiQueue: (bonusId: string) => void
}

export const useFreeSpinsBonusesStore = create<FreeSpinsBonusesStoreState & BonusesSlice>((set, get) => ({
    bonuses: [],
    setBonuses: (bonuses: FreeSpinsBonus[]) => {
        set({ bonuses })
    },
    activeBonus: undefined,
    setActiveBonus: (bonus?: FreeSpinsBonus) => {
        set({ activeBonus: bonus })
    },
    isRecovery: false,
    setIsRecovery: (isRecovery: boolean) => {
        set({ isRecovery })
    },
    isFreespinsPressStartCounterActive: false,
    setIsFreespinsPressStartCounterActive: (isActive: boolean) => {
        set({ isFreespinsPressStartCounterActive: isActive })
    },
    isBonusAlreadyClaimed: false,
    setIsBonusAlreadyClaimed: (isBonusAlreadyClaimed: boolean) => {
        set({ isBonusAlreadyClaimed })
    },
    isThereClaimingError: false,
    setIsThereClaimingError: (isThereClaimingError: boolean) => {
        set({ isThereClaimingError })
    },
    hasActiveBonusesLeft: false,
    setHasActiveBonusesLeft: (hasActiveBonusesLeft: boolean) => {
        set({ hasActiveBonusesLeft })
    },
    remainingSpins: 0,
    setRemainingSpins: (remainingSpins: number) => {
        set({ remainingSpins })
    },
    showRemainingSpinsBanner: false,
    setShowRemainingSpinsBanner: (shouldShow: boolean) => {
        set({ showRemainingSpinsBanner: shouldShow })
    },
    isModalOpened: false,
    setIsModalOpened: (isModalOpened: boolean) => set({ isModalOpened }),
    selectFlexiBonusOption: (option) => {
        const { selectedFlexiBonusOption } = get()

        if (selectedFlexiBonusOption && option && selectedFlexiBonusOption.betValue === option.betValue) {
            set({ selectedFlexiBonusOption: null })
        } else {
            set({ selectedFlexiBonusOption: option })
        }
    },
    selectedFlexiBonusOption: null,
    showFlexiIntroModal: false,
    setShowFlexiIntroModal: (show) => set({ showFlexiIntroModal: show }),
    flexiQueue: [],
    nonFlexiBonuses: [],
    setFlexiQueue: (bonuses) => set({ flexiQueue: bonuses }),
    setNonFlexiBonuses: (bonuses) => set({ nonFlexiBonuses: bonuses }),
    removeBonusFromFlexiQueue: (bonusId) =>
        set((state) => ({
            flexiQueue: state.flexiQueue.filter((b) => b.id !== bonusId),
        })),
    ...createBonusesSlice(set),
}))
